// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { DealershipService } from '@services/dealership.service';
import { SettingsService } from '@services/settings.service';
import { takeWhile } from 'rxjs';

@Component({
    selector: 'start-deal-jacket-help',
    templateUrl: './start-deal-jacket-help.component.html',
    styleUrls: ['./start-deal-jacket-help.component.scss'],
})
export class StartDealJacketHelpComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    public supportEmail: string;
    public tenantSupportPhone: string;

    constructor(
        private readonly dealershipService: DealershipService,
        private readonly settingsService: SettingsService
    ) {}
    ngOnDestroy() {
        this.isComponentAlive = false;
    }

    ngOnInit() {
        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe(async (dealer) => {
            ({ supportEmail: this.supportEmail, supportPhone: this.tenantSupportPhone } = await this.settingsService.getOemSettings(dealer.oemCode));
        });
    }
}
